import styled from 'styled-components';

export const Container = styled.form`
	width: 100%;
	padding: 20px;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 20px;
`;

export const Option = styled.div`
	width: 100%;
	flex-shrink: 0;

	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 8px;

	svg {
		width: 24px;
		height: 24px;
	}
`;

export const ToastCheckIcon = styled.div`
	width: 24px;
	height: 24px;
	svg {
		width: 24px;
		height: 24px;

		path {
			stroke: ${({ theme }) => theme['gray-secondary']};
		}
	}
`;
